function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Number, Object, String, dateRange, requestAnimationFrame) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'date-range-picker-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($helpers.showUpsell()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'upsell-header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": __vjadeStringifyAttrsIfObj({
                icon: 'lightning-bolt'
              }),
            }));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'upsell-text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  href: '/pricing',
                  target: '_blank'
                }),
                "class": {
                  'upgrade-link': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Upgrade your plan to query beyond " + ($helpers.maxHistoryDaysText()) + "");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'builder-pane-dropdown-container': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-select", {
            "attrs": __vjadeStringifyAttrsIfObj({
              options: JSON.stringify(dateRange.getDateRangeTypeDisplayOptions()),
              'selected-option': $helpers.DATE_RANGE_TYPE_DISPLAY_NAMES[dateRange.type],
            }),
            "on": {
              change: $helpers.changedDateRangeType,
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'date-range-picker': true
          },
        }, (function() {
          var __jade_nodes = [];
          const invalidDateRangeError = !$helpers.isValidDateRange();;
          const dateLimitedError = !invalidDateRangeError && !$helpers.isWithinMaxHistoryLimit();;
          __jade_nodes = __jade_nodes.concat(([$helpers.DateRangeType.RelativeAfter, $helpers.DateRangeType.RelativeBefore, $helpers.DateRangeType.NotRelativeAfter].includes(dateRange.type)) ? ((function() {
            var __jade_nodes = [];
            const {
              window
            } = dateRange;
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'relative-range-picker': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("input", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  type: `number`,
                  value: !Number.isInteger(window.value) ? `` : window.value,
                }),
                "on": {
                  mouseenter: $helpers.mouseenterRangeInput,
                  mouseleave: $helpers.mouseleaveRangeInput,
                  blur: $helpers.blurredRangeInput,
                  focus: $helpers.focusedRangeInput,
                  change: ev => ev.stopPropagation(),
                  input: $helpers.changedRelativeRangeValue,
                },
                "hook": {
                  insert: vnode => requestAnimationFrame(() => vnode.elm.select())
                },
                "key": dateRange.type,
                "class": Object.assign({}, {
                  'error': invalidDateRangeError || dateLimitedError,
                }, {
                  'relative-range-value': true
                }),
              }));
              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  options: JSON.stringify(dateRange.getTimeUnitOptions().map(unit => $helpers.TIME_UNIT_DISPLAY_NAMES[unit])),
                  'selected-option': $helpers.TIME_UNIT_DISPLAY_NAMES[window.unit],
                }),
                "on": {
                  change: $helpers.changedRelativeRangeUnit,
                },
              }));
              __jade_nodes = __jade_nodes.concat((dateLimitedError && $helpers.isRangeInputActive()) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": __vjadeStringifyAttrsIfObj({
                    type: `error`,
                    'always-show': true,
                  }),
                }, [__vjadeSafeCode($helpers.dateLimitedTooltipText())]));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-calendar-input", {
              "attrs": __vjadeStringifyAttrsIfObj($helpers.filterAttributes({
                from: dateRange.getCalendarFromDate() || ``,
                to: dateRange.getCalendarToDate() || ``,
                'max-date': $attr(`max-date`) || dateRange.getCalendarMaxDate(),
                'max-history-days': $helpers.maxHistoryDays(),
                'is-range': dateRange.type === $helpers.DateRangeType.Between || dateRange.type === $helpers.DateRangeType.NotBetween,
                'min-days-apart': 1,
                'show-upsell': $helpers.showUpsell(),
              })),
              "on": {
                change: $helpers.changedDates,
                draw: $helpers.propagateEvent,
              },
              "key": dateRange.type,
              "hook": {
                insert: $helpers.handleInsertCalendarInput
              },
            }));
            __jade_nodes = __jade_nodes.concat((dateRange.canUseRolling()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-checkbox", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  checked: dateRange.isRolling()
                }),
                "on": {
                  click: $helpers.clickedRollingCheckbox
                },
                "class": {
                  'rolling-checkbox': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'rolling-text': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat($helpers.getRollingCheckboxText());
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'rolling-info-icon': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                      "attrs": __vjadeStringifyAttrsIfObj({
                        icon: `info`
                      }),
                    }));
                    __jade_nodes = __jade_nodes.concat(h("mp-tooltip", [__vjadeSafeCode($helpers.getRollingInfoText())]));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(($helpers.showMaxDateContext()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'date-range-picker-context': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'date-range-picker-context-text': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat($helpers.maxDateContextText());
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": Object.assign({}, {
                    'override-z-index': $helpers.overrideMaxDateContextZIndex()
                  }, {
                    'date-range-picker-context-icon': true
                  }),
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": __vjadeStringifyAttrsIfObj({
                      icon: `info`
                    }),
                  }));
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", [__vjadeSafeCode($helpers.maxDateTooltipText())]));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Number" in locals ? locals.Number : typeof Number !== "undefined" ? Number : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "dateRange" in locals ? locals.dateRange : typeof dateRange !== "undefined" ? dateRange : undefined, "requestAnimationFrame" in locals ? locals.requestAnimationFrame : typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;